export const INVOICE_MESSAGE = 'Please import the downloaded file on the QuickBooks to generate the Invoice';
